// src/api/endpoints.ts
export const API_ENDPOINTS = {
  auth: {
    FIND_USERNAME: '/login/findByUserName', // Updated endpoint for finding user by username
    LOGIN: '/auth',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh-token',
    // Add other auth-related endpoints here
    CAPTCHA: '/auth/captcha/generate',
  },
  dashboard: {
    DASHBOARD_ANALYTIC: '/dashboard/get-dashboard-analytic',
    CRITICAL_ALERTS: '/dashboard/get-critical-alerts',
    ANALYTIC: '/dashboard/get-dashboard-analytic',
    TOTAL_VEHICLES: 'dashboard/get-all-vehicle-by-type',
    FLEET_STATUS: '/dashboard/get-vehicle-current-status',
    FUEL_TILES: '/vehicle/fuel-tiles',
    FLEET_ALL_STATUS: '/dashboard/get-allvehicle-current-status',
    VALID_VIDEO_CHECK: '/driver/validVideo?customerId=',
    IGNITION_TRIPS: '/dashboard/get-ignition-based-trip',
    IGNITION_BASE_TRIPS: '/ignition-trips/getIgnitionTripPagination',
    TABLE_GRAPH: '/dashboard/get-dashboard-graphical-analytic',
    VEHICLE_TABLE_GRAPH: '/vehicle-dashboard/get-dashboard-graphical-analytic',
    DRIVER: '/driver/getAllDrivers/',
    ADDRESS_CODE: '/address/',
    STOP_LIVE_STREAMING: '/live-stream/stop/',
    GROUP: '/group/',
    CALLING: '/communication/',
    CREATE_VOD: '/vod-request/createVod',
    WATCH_VOD: '/vod-request/watch-vod',
    FETCH_VOD: '/vod-request/fetch-Vod',
    STOP_CALLING: '/communication/stop/',
    LIVE_STREAM: '/live-stream/',
    LIVE_STREAM_V2: '/live-stream/v2/',
    LIVE_STREAM_ALERT: '/live-stream/alert/',
    ROUTE_PATH: '/route/getRoutePath',
    TRIP_CODE: '/trips/get-trip-code/',
    VEHICLE: '/dashboard/get-all-vehicle-by-type',
    FETCH_DRIVER_VIDEO: '/driver/fetchVideoFromWarningForDriverRegistration',
    ADD_ADDERESS: '/address',
    ROUTE_CODE: '/route/get-route-code/',
    ALL_ROUTE: '/route/getAllRouteWithoutPagination/',
    ADD_ROUTE: '/route',
    ALL_ADDRESS: '/address/getAddressWithoutPagination/',
    ALL_ADDRESS_PAGINATION: '/address/getAllAddress',
    ALL_WARNINGS: '/dashboard/get-all-warning',
    ALL_WARNING_PAGINATION: '/dashboard/get-all-warning-with-pagination',
    CRITICAL_DEVICE: '/dashboard/get-device-critical-error',
    IDEAL_TIME: '/dashboard/get-ideal-time-with-pagination',
    CRITICAL_DRIVER_SCORE: '/dashboard/get-critical-driver-safety-score',
    FLEET_SAFETY_SCORE: '/dashboard/get-driver-safety-score',
    SOS_WARNING: '/dashboard/get-sos-warning',
    SAFETY_DASHBOARD_ANALYTICS: '/safety-Dashboard-Table/get-warning-table',
    DRIVER_DOC_UPLOAD: '/driver/uploadDocuments?customerId=',
    GET_ROUTES: '/route/getAllRoute',
    GET_ADDRESS: '/address/getAllAddress',
    GET_ROUTE_COUNT: '/route/count',
    GET_ADDRESS_COUNT: '/address/count',
    SHARE_TRIP_DETAILS: '/ignition/share/trip-details',
    DOWNLOAD_TRIP_DETAILS: '/trips/download',
    VALID_TOKEN: '/api/external/valid-token/',
    NETWORKSTRENGTH: '/communication/signal',
    GET_VEHICLE_DETAILS: '/device/fetchByVehicleId/',
    GET_DRIVER_DOCUMENTS_URL: '/driver/file-url',
    GET_DRIVER_DOCUMENTS_URL_NEW: '/driver/file-url-new',
    CALLING_LOG: '/communication/call/history',
    GET_MANAGE_SECTION_UI: '/dashboard/get-dashboard-ui-features',
    UPDATE_MANAGE_SECTION_UI: '/dashboard/update-dashboard-ui-features',
  },
  trip: {
    TRIP_DETAIL: '/ignition-trips/getTripOverView',
    TRIP_ANALYTICS: '/trips/count/',
    TRIP_FILTER: '/trips/filter',
    CLONE_TRIP: '/trips/cloneTrip',
    GET_FOOTAGE_DATA: '/footage/getFootageData',
    GET_SINGLE_VIDEO_CLIP: '/footage/getSdCardVideoClip',
    GET_TRIP_ALERT_DETAIL: '/trips/getTripAlertsByDeviceIdAndSortKey',
    GET_TRIP_ALERT: '/trips/getTripAlerts',
    GET_TRIPS: '/trips/getAllTrip',
    TRIP_OVERVIEW: '/trips/getTripOverView',
    TRIPS: '/trips/',
    ADD_TRIPS: '/trips',
    GET_IGNITION_TRIPS: '/ignition-trips/getIgnitionTripPagination',
    FILTER_IGNITION_TRIPS: '/ignition-trips/filterIgnitionTrip',
    ADD_IGNITION_COMMENT: '/ignition-trips/addComment',
    DOWNLOAD_IGNITION_TRIPS: '/ignition-trips/download',
    GET_ALL_IGNITION_TRIPS: '/ignition-trips/',
    GET_ALL_FILTERED_IGNITION_TRIPS: '/ignition-trips/filteredIgnitionTripSummary',
    TRIP_BULK_UPLOAD: '/trips/trip-bulk-upload',
    TRIP_SAMPLE_DOWNLOAD: '/download-sample-file/trip',
    ONGOING_TRIPS_BY_FLEET: '/trips/ongoing-trips-by-fleetId',
  },
  directories: {
    ADD_VEHICLE: '/vehicle/save',
    ADD_DRIVER: '/driver/save',
    GEOFENCE_DELETE: '/geofence/delete',
    GET_DRIVERS_COUNT: '/driver/getDriverCount',
    GET_DRIVER_DETAIL: '/driver/getDriverDetails/',
    PERFORMNCE_COUNT: '/driver-performance/count',
    GET_ALL_DRIVER: '/driver/getAllDriversByFleet',
    PERFORMANCE_DRIVER: '/driver-performance/getTopAndBottomDriverList',
    GET_DRIVER: '/driver/getAllDriverWithoutPagination',
    EDIT_GEOFENCE: '/geofence/edit',
    ROUTES_DOWNLOAD: '/route/download',
    ROUTE_SINGLE_DOWNLOAD: '/route/download',
    ADDRESS_FILTER: '/address/filter',
    GEOFENCE_FILTER: '/geofence/filterGeofence',
    ROUTES_FILTER: '/route/filter',
    GET_ALL_VEHICLES: '/vehicle/get-all-vehicle',
    DRIVING_SCORE: '/driver-performance/getAllDriversScore',
    DRIVER_PERFORMANCE_FIVE: '/driver-performance/performance',
    DRIVER_SCORE_AND_ALERT: '/driver-performance/getDriverScoreAndAlertByDriverId',
    DRIVER_SCORE_TREND: '/driver-performance/getDriverScoreTrend',
    DELETE_VEHICLE: '/vehicle/delete',
    DRIVER_SPECIFIC_CARD: '/driver-performance/getSpecificDriverCard',
    VEHICLE_TILES: '/vehicle/vehicle-tiles-count',
    VEHICLE_DOWNLOAD: '/vehicle/download',
    GET_ADDRESS_DETAIL: '/address/',
    DRIVER_ALERT_TREND: '/driver-performance/getDriverAlertTrend',
    ADDRESS_DELETE: '/address/delete',
    ADDRESS_DOWNLOAD: '/address/download',
    GROUPS_DETAIL: '/group/getSingleGroup/',
    GEOFENCE_DOWNLOAD: '/geofence/download',
    GET_GEOFENCE_COUNT: '/geofence/getAllGeofenceSummary',
    ADD_GEOFENCE: '/geofence/save',
    GET_ALL_GEOFENCE_PAGINATION: '/geofence/getAllGeofencePagination',
    GET_ALL_GEOFENCE: '/geofence/getAllGeofence',
    VEHICLE_BULK_UPLOAD: '/vehicle/vehicle-bulk-upload',
    VEHICLE_SAMPLE_DOWNLOAD: '/download-sample-file/vehicle',
    GEOFENCE_BULK_UPLOAD: '/geofence/geofence-bulk-upload',
    GEOFENCE_SAMPLE_DOWNLOAD: '/download-sample-file/geofence',
    DEVICE_BULK_UPLOAD: 'device/device-bulk-upload',
    DEVICE_SAMPLE_DOWNLOAD: '/download-sample-file/device',
    ADDRESS_BULK_UPLOAD: '/address/address-bulk-upload',
    ADDRESS_SAMPLE_DOWNLOAD: '/download-sample-file/address',
    ROUTE_BULK_UPLOAD: '/route/route-bulk-upload',
    ROUTE_SAMPLE_DOWNLOAD: '/download-sample-file/route',
    VEHICLE_DEVICE_EXIST: '/vehicle/isDeviceExist',
    VEHICLE_REGISTRATION_EXIST: '/vehicle/isVehicleExist',
    GET_FOOTAGE: '/footage/getFootageData',
    VEHICLE_EDIT: '/vehicle/edit',
    GET_ALL_DEVICES: '/device/get-all-device',
    GET_ALL_DEVICES_SUPERADMIN: '/device/get-all-devices-superadmin',
    DOWNLOAD_DEVICES_SUPERADMIN: '/device/download-superadmin',
    GET_ALL_DEVICES_FILTERED: '/device/get-all-registered-device',
    GET_ALL_DEVICES_SUPERADMIN_PAGINATION: '/device/get-all-devices-superadmin-pagination',
    GET_DEVICE_DETAIL: '/device/fetchByDeviceId',
    DEVICE_TILES_COUNT: '/device/device-tiles-count',
    GET_ALL_DEVICE_PAGINATION: '/device/get-all-device-pagination',
    DEVICE_DELETE: 'device/delete',
    ADD_DEVICE: 'device/save',
    EDIT_DEVICE: '/device/edit',
    DEVICE_DOWNLOAD: 'device/download',
    GROUP: '/group/',
    GET_ALL_GROUP: '/group/getAllGroups/',
    DRIVER_DOWNLOAD: '/driver/download',
    ADD_NEW_GROUP: '/group/save',
    GROUP_DOWNLOAD: '/group/download',
    GROUP_DELETE: '/group/delete',
    GROUP_EDIT: '/group/edit',
    GET_ALL_VIDEOS: '/vod-request/fetch-Vod',
    GET_VIDEOS_URL: '/vod-request/watch-vod',
    ADD_VIDEO: '/vod-request/createVod',
    GET_CAMERA: '/vod-request/getCamera/',
    ROUTE_DETAILS: '/route/routeDetails',
    GROUP_TILES_COUNT: '/group/group-tiles-count',
    VEHICLE_DETAILS: '/vehicle/get-vehicle-details',
    FILTERED_VIDEOS: '/vod-request/filter-vod',
    VEHICLE_RUNNING_HISTORY: '/vehicle/get-vehicle-running-history',
    VEHICLE_TRIP_RUNNING_HISTORY: '/vehicle/get-vehicle-trip-history',
    VEHICLE_TRIP_SUMMARY: '/vehicle/get-vehicle-summary',
    GET_VEHICLE_RUNNING_MAP: '/vehicle/get-vehicle-running-map',
    GET_VEHICLE_RUNNING_MAP_ALERTS: '/vehicle/get-vehicle-running-map-alerts',
    ROUTES_DELETE: '/route/delete',
    DRIVER_DELETE: '/driver/delete',
    DRIVER_EDIT: '/driver/edit',
    GET_DRIVER_DETAIL_V2: '/driver/driverDetailsV2',
    DRIVER_PERFORMANCE_DOWNLOAD: '/driver-performance/download',
    VEHICLEPRODUCTTYPE: '/vehicle/productType',
    FETCH_DRIVER_STAFF: '/driver/fetch-staff',
  },
  broadcast: {
    create: '/broadcast/create',
    edit: '/broadcast/edit',
    getAll: '/broadcast/getAll',
    delete: '/broadcast/delete',
    download: '/broadcast/download',
    getSingle: '/broadcast/getSingleBroadcast',
  },
  report: {
    MANAGER_REPORT: '/manager-report',
    MANAGER_REPORT_MONTHLY: '/manager-report/monthly',
    MANAGER_DOWNLOAD: '/manager-report/download',
    MANAGER_DOWNLOAD_MONTHLY: '/manager-report/download/monthly',
    SEND_MANAGER_REPORT_DATA: '/manager-report/send-email',
    SEND_MANAGER_REPORT_DATA_MONTHLY: '/manager-report/send-email/monthly',
    ALARM_REPORT: '/alarm-report',
    ALARM_DOWNLOAD: '/alarm-report/download',
    SEND_ALARM_REPORT_DATA: '/alarm-report/send-email',
    DRIVER_REPORT: '/driver-performance-report',
    DRIVER_REPORT_MONTHLY: '/driver-performance-report/monthly',
    DRIVER_DOWNLOAD: '/driver-performance-report/download',
    DRIVER_DOWNLOAD_MONTHLY: '/driver-performance-report/download/monthly',
    SEND_DRIVER_REPORT_DATA: '/driver-performance-report/send-email',
    SEND_DRIVER_REPORT_DATA_MONTHLY: '/driver-performance-report/send-email/monthly',
    DEVICE_IGNITION_REPORT: '/vehicle-ignition-report',
    DEVICE_IGNITION_DOWNLOAD: '/vehicle-ignition-report/download',
    SEND_DEVICE_IGNITION_REPORT_DATA: '/vehicle-ignition-report/send-email',
    DEVICE_HEALTH_REPORT: '/device-health-report/v2',
    DEVICE_HEALTH_DOWNLOAD: '/device-health-report/download',
    SEND_DEVICE_HEALTH_REPORT_DATA: '/device-health-report/send-email',
    DEVICE_KM_REPORT: '/vehicle-distance-run-report',
    DEVICE_KM_DOWNLOAD: '/vehicle-distance-run-report/download',
    SEND_DEVICE_KM_REPORT_DATA: '/vehicle-distance-run-report/send-email',
    DEVICE_RUN_REPORT: '/daily-run-report',
    DEVICE_RUN_DOWNLOAD: '/daily-run-report/download',
    SEND_DEVICE_RUN_REPORT_DATA: '/daily-run-report/send-email',
    DAILY_EVENT_REPORT: '/daily-event-report',
    DAILY_EVENT_DOWNLOAD: '/daily-event-report/download',
    SEND_DAILY_EVENT_REPORT_DATA: '/daily-event-report/send-email',
    NIGHT_DRIVE_REPORT: '/night-driving-report',
    NIGHT_DRIVE_DOWNLOAD: '/night-driving-report/download',
    SEND_NIGHT_DRIVE_REPORT_DATA: '/night-driving-report/send-email',
    CAMERA_BLOCK_REPORT: '/cameraBlock-report',
    CAMERA_BLOCK_DOWNLOAD: '/cameraBlock-report/download',
    SEND_CAMERA_BLOCK_REPORT_DATA: '/cameraBlock-report/send-email',
    CONTINOUS_DRIVE_REPORT: '/continuous-driving-report',
    CONTINOUS_DRIVE_DOWNLOAD: '/continuous-driving-report/download',
    SEND_CONTINOUS_DRIVE_REPORT_DATA: '/continuous-driving-report/send-email',
    STOPPAGE_REPORT: '/stoppage-report',
    STOPPAGE_DOWNLOAD: '/stoppage-report/download',
    SEND_STOPPAGE_REPORT_DATA: '/stoppage-report/send-email',
    GEOFENCE_REPORT: '/geofence-report',
    GEOFENCE_DOWNLOAD: '/geofence/download',
    GEOFENCE_REPORT_DOWNLOAD: '/geofence-report/download',
    SEND_GEOFENCE_REPORT_DATA: '/geofence-report/send-email',
    ELOCK_REPORT: '/elock-report',
    ELOCK_DOWNLOAD: '/elock-report/download',
    SEND_ELOCK_REPORT_DATA: '/elock-report/send-email',
    TRIP_VEHICLE_SUMMARY: '/trip-vehicle-summary-report',
    TRIP_VEHICLE_SUMMARY_DOWNLOAD: '/trip-vehicle-summary-report/download',
    SEND_TRIP_VEHICLE_SUMMARY_DATA: '/trip-vehicle-summary-report/send-email',
    SCHEDULED_REPORTS: '/scheduled-report',
    MASTER_REPORTS: '/master-report',
    SCHEDULED_REPORTS_SAVE: '/scheduled-report/save',
    SCHEDULED_REPORTS_EDIT: '/scheduled-report/edit',
    SCHEDULED_REPORTS_STATUS_CHANGE: '/scheduled-report/toggle-status',
    SCHEDULED_REPORTS_DELETE: '/scheduled-report/delete',
    CUSTOM_REPORT_CREATE: '/custom-report/save',
    CUSTOM_REPORT_DATA: '/custom-report/getAll',
    CUSTOM_REPORT_DATA_SINGLE: '/custom-report/get',
    CUSTOM_REPORT_DATA_VALUE: '/custom-report/generate',
    CUSTOM_REPORT_DELETE: '/custom-report/delete',
    CUSTOM_REPORT_EDIT: '/custom-report/edit',
    CUSTOM_REPORT_RECENTLY: '/custom-report/getRecentGenerated',
    CUSTOM_REPORT_SEND_EMAIL: '/custom-report/send-email',
    CUSTOM_REPORT_SEND_DOWNLOAD: '/custom-report/download',
    PASSENGER_OCCUPANCY_REPORT: '/passenger-occupancy-report',
    FETCHENTRY_COUNT: '/passenger-occupancy-report/fetchEntryCount',
    PASSENGER_OCCUPANCY_DOWNLOAD: '/passenger-occupancy-report/download',
    DRIVER_DAILY_RUN_REPORT_DOWNLOAD: '/driver/report/daily-run-report',
    DRIVER_REPORT_WEEKLY_OFF_DONWLOAD: '/driver/report/weekly-off',
    DRIVER_ATTENDANCE_REPORT_DOWNLOAD: '/driver-performance/download-attendance-report',
    DRIVER_DAILY_RUN_REPORT_FETCH: '/driver/report/fetch-daily-run-report',
    DRIVER_ATTENDANCE_REPORT_FETCH: '/driver-performance/fetch-attendance-report',
  },
  notification: {
    MARK_AS_READ: '/notification/mark-as-read',
    NOTIFICATION_HISTORY: '/notification/history',
  },
  track: {
    VEHICLE_TRACK: '/vehicle/getCurrentStatus/',
  },
  support: {
    CREATE_TICKET: '/support/createTicket',
    EDIT_TICKET: '/support/editTicket',
    GET_ALL_TICKETS: '/support/getAllTickets',
    GET_SINGLE_TICKET_SUPER_ADMIN: '/support/getSingleTicketBySuperAdminId',
    DELETE_TIKCET: '/support/deleteTicket',
    GET_ALL_TICKETS_STATUS: '/support/getAllTicketsByStatus',
    GET_SINGLE_TICKET: '/support/getSingleTicket',
    SHARE_SUPPORT_TICKET: '/share/support-ticket',
    SUPPORT_DOWNLOAD: '/support/download',
    FILTER_TICKETS: '/support/filter',
    SUPPORT_DOCUMENT_URL: 'support/media-url',
    SUPPORT_DOCUMENT_URL_NEW: 'support/media-url-new',
    SEARCH_TICKETS: '/support/search',
  },
  sdCard: {
    GET_FOOTAGE: '/footage/getFootageData',
    GET_FOOTAGE_URL: '/footage/getVP2SdCardStreamUrl',
    UPLOAD_FOOTAGE: '/footage/uploadSdCardVideoClip',
    DOWNLOAD_VIDEO: '/footage/getSdCardVideoClip',
    DEMO_LIVE_STREAMING: '/live-stream/demo-live-stream',
  },
  alarm: {
    VEHICLE_ALERT_ANALYTICS: '/vehicle-alert',
    VEHICLE_ALERT_ALL_WARNING: '/vehicle-alert/get-all-warning-type',
    VEHICLE_PAGINATED_ALERT_BY_WARNING: '/vehicle-alert/get-pagination-alert',
    VEHICLE_ALL_ALERTS_BY_WARNING: '/vehicle-alert/get-all-alert-by-warning-type',
    VEHICLE_ALERT_COMMENT: '/vehicle-alert/add-comment-alert',
    VEHICLE_ALERT_EMAIL: '/share/alert-details',
    SHARE_ALERT_DETAILS_EMAIL: '/share/alert-details',
    DRIVER_ALERT_ALL_WARNING: '/driver-alert/get-all-warning-type',
    DRIVER_PAGINATED_ALERT_BY_WARNING: '/driver-alert/get-pagination-alert',
    DRIVER_ALERT_TREND_CHART: '/driver-alert/trend-chart',
    DRIVER_ALERT_LIST: '/driver-performance/getAllDriversScoreAndAlert',
    GET_DRIVER_ALERT_COUNT: '/driver-alert/driver-analytic',
    GET_DRIVERS_ALERT_COUNT: '/driver-alert/all-driver-analytic',
    DRIVER_ALERT_INCIDENT_CHART: '/driver-alert/driver-incident-chart',
    VEHICLE_ALERT_DETAILS: '/vehicle-alert/getAlertDetails',
    ALERTS_VIDE0_URL_SECONDARY: '/api/external/get-alert-video-on-demand',
    DRIVER_COACHING_SHARE_LINK: '/share/link',
    DRIVER_PERFORMANCE_TOP_BOTTOM: '/driver-performance/fetchTopAndBottomDriverList',
    UPDATE_WARNING_STATUS: '/vehicle-alert/update-warning-by-deviceId-sort-key-for-read-data',
    DRIVER_ALERT_BY_DRIVER_OR_VEHICLE: '/driver-alert/by-driver-or-vehicle',
    DRIVER_ALERT_DOWNLOAD: '/driver-alert/download',
  },
  users: {
    CREATE_USER: '/users',
    USER_LIST_DATA: '/users/user-list',
    USER_DOWNLOAD: '/users/download',
    USER_ACTIVATE_DEACTIVATE: '/users/user-deactivate',
    USER_ACTIVATE_ROLE: '/users/getRole',
    USER_ACTIVE_DELETE: '/users/user-delete',
    DEVICE_LOGS: '/device-logs/fetch',
    COMPANY_LIST: '/company/list',
    CUSTOMER_LIST_CRN: '/users/getAllCustomerByCrn',
    CUSTOMER_LIST_DEVICES: '/device/get-all-device',
    DEVICE_LOG_REQUEST: '/device-logs/request',
    DEVICE_LOG_SAVE: '/device-logs/save',
    DEVICE_LOGS_DOWNLOAD: '/device-logs/download',
    DEVICE_CERTIFICATE_DELETE: '/certificate/delete',
    DEVICE_DATA_DELETE: '/device-logs/remove',
    DEVICE_OTA_APK_FETCH: '/device-ota/fetch-device-ota',
    DEVICE_OTA_APK_LIST: '/device-ota/apk-list',
    DEVICE_OTA_APK_SAVE: '/device-ota/save-device-ota',
    DEVICE_REBOOT: '/reboot',
    DEVICE_UPLOAD_APK: '/device-ota/save-apk',
    MANAGE_ALERTS_UI: '/manage-alerts/ui',
    MANAGE_ALERT_SAVE: '/manage-alerts/save',
    ALARM_INVALID_SEND_REQUEST: '/api/alarm-invalid/send-request',
    ALARM_INVALID_CHECK_LIVE_CONFIG: '/api/alarm-invalid/check-live-config',
    USER_SETTINGS_DATA: '/feature-access/featureType',
    USER_SETTINGS_FETCH: '/feature-access/fetch',
    USER_SETTING_SAVE: '/feature-access/save',
    ADMIN_LIVESTREAMING_GET: '/live-stream/v1/getSetup',
    ADMIN_LIVE_STREAMING_SAVE: '/live-stream/v1/setup',
    ADMIN_USER_CONTROLS_PERMISSIONS_GET: '/permission/fetch',
    ADMIN_USER_GET_PERMISSION_BY_ID: '/permission/getUserPermissionByUserId',
    ADMIN_USER_UPDATE_PERMISSION_BY_ID: '/permission/saveOrUpdateUserPermission',
    ADMIN_USER_CONTROL_PERMISSION_ADD_MENU: '/permission/saveMenu',
    ADMIN_USER_CONTROL_PERMISSION_ADD_SUB_MENU: '/permission/saveSubMenu',
    USER_BANNER_CREATE: '/banner/save',
    USER_BANNER_FETCH: '/banner/fetch',
    USER_BANNER_UPDATE: '/banner/update-banner',
    USER_SHOW_BANNER: '/banner/show-banner',
    USER_CROSS_BANNER: '/banner/cross-banner',
    SUPERADMIN_USERS_LIST: '/users/fetch-internal-user',
    COMPANY_ADD: '/company/add',
    CREATE_USERS: '/users/add',
    COMPANY_NAMES: '/company/companyNames',
    COMPANY_EXISTENCE: '/company/companyexistance/',
    USER_EXISTENCE: '/users/checkexistanceuser/',
    COMPANY_DELETE: '/company/delete/',
  },
  videoBlur: {
    USERDATA_MASKING: '/feature-access/fetch',
    IOT_DEVICE_BY_DEVICE_ID: '/device/fetchByDeviceId',
    BLUR_CROPPED_VIDEO: '/blur/getMLParamConfigForBlurByDeviceId',
    BLUR_VIDEO_PROCESSING: '/blur-video/react/process-url',
  },
  fleetgpt: {
    FLEETGPT_FREEVERSION: '/fleetGptSubscription/freeVersion',
    CHECK_FLEETGPT_SUBSCRIPTION_VALIDITY: '/fleetGptSubscription/checkSubscriptionValidity/',
  },
  coaching: {
    DRIVER_COACHING_FETCH: '/driver-coaching/fetch',
    DRIVER_COACHING_FILTER: '/driver-coaching/filter',
    DRIVER_COACHING_DOWNLOAD: '/driver-coaching/download',
    DRIVER_COACHING_TILES: '/driver-coaching/card',
    DRIVER_COACHING_VIDEOS: '/driver-coaching/video',
    CUSTOM_DRIVER_COACHING: '/driver-coaching/create',
    DRIVER_COACHINGPROGRESS_SAVE: '/driver-coaching/saveDriverProgress',
    DRIVER_COACHING_ADD_COMMENT: '/driver-coaching/add-comment',
    DRIVER_COACHING_ADD_TRAINING_DATE: '/driver-coaching/add-training-date',
    DRIVER_COACHING_ADD_TRAINING_DATE_COMMENT: '/driver-coaching/add-training-date-comment',
    DRIVER_DO_DONT: '/driver-coaching/getSafetyGuidelines',
  },
  shareLink: {
    SHARE_LINK: '/vehicle/requestToGenerateLink',
    SHARE_VEHICLE_CURRENT: '/share/vehicle-running-link',
    VIDEO_PLAYBACK_SHARE: '/share/video-playback',
  },
  google: {
    GOOGLE_ADDRESS: '/google/address',
  },
  utility: {
    WAKEUP_DEVICE: '/utility/wakeup-device',
    SLEEP_DEVICE: '/utility/sleep-device',
    GET_TIMEZONE: '/utility/get-timezone',
  },
  documents: {
    DOCUMENT_CATEGORY: '/api/documents/categories',
    DOCUMENTS_LISTING: '/api/documents/list',
    DOCUMENTS_TYPES: '/api/documents/document-types',
    DOCUMENT_SAVE: '/api/documents/add',
    DOCUMENT_EDIT: '/api/documents/edit',
    DOCUMENT_DELETE: '/api/documents/delete',
    openDocument: '/api/documents/doc-url',
    DOCUMENT_MODAL_URL: '/api/documents/doc-url-new',
  },
  clientSubscription: {
    FETCH_SUBSCRIPTION: '/channel/fetch',
    CREATE_SUBSCRIPTION: '/channel/save',
    PRODUCT_ITEMS: '/channel/item',
    UPDATE_SUBSCRIPTION: '/channel/update',
    DOWNLOAD_SUBSCRIPTION: '/channel/download',
    BULK_UPLOAD: '/channel/bulk-upload',
    SAMPLE_FILE_BULK_DOWNLOAD: '/download-sample-file/channel-partner',
    DEVICE_ITEM_TYPE: '/channel/itemType',
    END_SUBSCRIPTION: '/channel/delete',
    RENEWS_SUBSCRIPTION: '/channel/renew',
    SHARESUBSCRIPTION_SUPPORT_TEAM: '/share/send-support-team',
  },
  expense: {
    ADD_EXPENSE: '/expense/add',
    GET_EXPENSE_BY_DATE_RANGE: '/expense/by-fleet',
    DOC_URL_NEW: '/expense/doc-url-new',
    DELETE_EXPENSE: '/expense',
    DOWNLOAD_EXPENSE: '/expense/download',
    DOWNLOAD_BULK_TEMPLATE: '/expense/download/bulk/template',
    BULK_UPLOAD: '/expense/bulk/upload',
  },
  maintenance: {
    SCHEDULE_SERVICE_FETCH: '/schedule-service/fleet',
    SCHEDULE_SERVICE_CREATE: '/schedule-service/create',
    SCHEDULE_SERVICE_DELETE: '/schedule-service',

    MAINTENANCE_SERVICE_FETCH: '/maintenance/service/fleet',
    SERVICE_RECORDS_SERVICE_CREATE: '/maintenance/service/add',
    SERVICE_RECORDS_DOC_URL_NEW: '/maintenance/service/doc-url-new',
    SERVICE_RESORDS_EDIT: '/maintenance/service/update',
    SERVICE_RECORDS_DELETE: '/maintenance/service/delete',
  },
  twoWayCommunication: {
    END_CALL: '/call/end',
  },
  serviceMaster: {
    SERVICE_MASTER_FETCH: '/service-master/fetch',
  }
};
